// extracted by mini-css-extract-plugin
export default {"stepper":"ManualLoanEntryPage_stepper__2kS6K","optionalCaption":"ManualLoanEntryPage_optionalCaption__XPTd6"};